"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const randomkey_1 = __importDefault(require("@common/tsutils/randomkey"));
const FilterValue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/FilterValue"));
/**
 * This associates a possible filter with its real value
 */
class FilterWithValue {
    constructor() {
        this.filter = null;
        this.value = new FilterValue_1.default();
        this.key = (0, randomkey_1.default)();
    }
    reset() {
        this.value = new FilterValue_1.default();
    }
}
exports.default = FilterWithValue;
